import { reviews } from '@/mocks/data';

export default function ReviewSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              用户真实评价
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              来自数百万用户的真实反馈，是我们不断前行的动力
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="p-5 md:p-6 rounded-2xl bg-background-50 flex flex-col"
              >
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-4">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>

                <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-1">
                  &ldquo;{review.content}&rdquo;
                </p>

                <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-medium text-foreground-900">
                      {review.name}
                    </div>
                    <div className="text-xs text-foreground-400">
                      {review.role}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}